import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

// Default fallbacks — used until /api/settings arrives.
const DEFAULTS = {
  brand_name: "Vedacosmos",
  tagline: "Ancient Wisdom. Modern Technology.",
  address_line1: "Vrindavan",
  address_line2: "Mathura, Uttar Pradesh, India",
  phone_1: "+91 86799 94271",
  phone_2: "+91 86799 94272",
  whatsapp_number: "918679994272",
  email: "help@vedacosmos.com",
  android_url: "",
  ios_url: "",
  instagram_url: "",
  youtube_url: "",
  twitter_url: "",
  telegram_url: "",
  commission_pct: 20,
  show_services: true,
  show_kundali_feature: true,
  show_live_events: true,
  show_marketplace_preview: true,
  show_testimonials: true,
  show_app_banner: true,
  show_final_cta: true,
};

const SettingsContext = createContext(DEFAULTS);

export function SettingsProvider({ children }) {
  const [s, setS] = useState(DEFAULTS);

  const refresh = async () => {
    try {
      const { data } = await api.get("/settings");
      setS({ ...DEFAULTS, ...data });
    } catch (err) {
      console.warn("Settings fetch failed, using defaults:", err);
    }
  };

  useEffect(() => { refresh(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  const waLink = (msg = "") =>
    `https://wa.me/${s.whatsapp_number}?text=${encodeURIComponent(
      msg || "Namaste Vedacosmos 🕉️  I would like to know more about your services."
    )}`;

  return (
    <SettingsContext.Provider value={{ ...s, refresh, waLink }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
